import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCar = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 21,
	viewBox: "0 0 20 21",
	width: 20,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "#000",
		strokeLinecap: "square",
		strokeOpacity: .87,
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m1.25 9.25h17.5" }),
			/* @__PURE__ */ _jsx("path", { d: "m17.5 14.25v1.875c0 .1658-.0658.3247-.1831.4419-.1172.1173-.2761.1831-.4419.1831h-1.875c-.1658 0-.3247-.0658-.4419-.1831-.1173-.1172-.1831-.2761-.1831-.4419v-1.875" }),
			/* @__PURE__ */ _jsx("path", { d: "m5.625 14.25v1.875c0 .1658-.06585.3247-.18306.4419-.11721.1173-.27618.1831-.44194.1831h-1.875c-.16576 0-.32473-.0658-.44194-.1831-.11721-.1172-.18306-.2761-.18306-.4419v-1.875" }),
			/* @__PURE__ */ _jsx("path", { d: "m5 11.75h1.25" }),
			/* @__PURE__ */ _jsx("path", { d: "m13.75 11.75h1.25" }),
			/* @__PURE__ */ _jsx("path", { d: "m17.5 9.25-2.3352-5.25391c-.0491-.11045-.1292-.2043-.2305-.27017-.1014-.06586-.2197-.10092-.3405-.10092h-9.18755c-.12088 0-.23917.03506-.34053.10092-.10137.06587-.18146.15972-.23056.27017l-2.33516 5.25391v5h15z" })
		]
	})
});
export default SvgCar;
